// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"abb6f0794ace5588ae1f","303":"b1d2a929cc5f2d1e31f2","495":"574fc8f30579217b8396"}[chunkId] + ".js";
};